import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GetMemberNamePipe } from './get-member-name.pipe';
import { GetValuePipe } from './get-value.pipe';
import { RenderTemplatePipe } from './render-template.pipe';


const pipes = [GetMemberNamePipe, GetValuePipe, RenderTemplatePipe];

@NgModule({
  declarations: pipes,
  imports: [CommonModule, TranslateModule],
  exports: pipes,
})
export class FormioPipesModule {}
